import React from 'react';
import { CoreForumViewNode } from '../core/CoreForumViewNode';

/**
 * ChatRoomViewNode - ChatRoom 专用的节点查看组件包装器
 * @param {Function} props.buildGroupContext - 从页面传递的 context 构建函数
 * @param {string} props.mode - 模式标识
 */
export const ChatRoomViewNode = ({ 
  open, 
  onClose, 
  nodeContent, 
  ws, 
  groupId, 
  onEditorOpen, 
  onEditorClose, 
  graphNodes, 
  graphEdges = [], // 新增：接收 edges
  allTagConfigs = {},
  buildGroupContext,
  mode = 'chat',
  onRefresh,
  onNodeUpdated,
  onNodeDeleted
}) => {
  return (
    <CoreForumViewNode
      open={open}
      onClose={onClose}
      nodeContent={nodeContent}
      ws={ws}
      groupId={groupId}
      onEditorOpen={onEditorOpen}
      onEditorClose={onEditorClose}
      graphNodes={graphNodes}
      graphEdges={graphEdges} // 传递 edges
      allTagConfigs={allTagConfigs}
      buildGroupContext={buildGroupContext}
      mode={mode}
      onRefresh={onRefresh}
      onNodeUpdated={onNodeUpdated}
      onNodeDeleted={onNodeDeleted}
    />
  );
};